export const DESIGN_SYSTEM_PATH = "/design-system";
